export const API_BASE_URL = 'https://events-store.b.goit.study/api';
export const API_ENDPOINTS = {
  CATEGORIES: '/categories',
  EVENTS: '/events',
  LIMIT: 8,
};
